import styled, { css } from 'styled-components';
import neutral from '../../themes/neutral/index.js';

var WarningFocus = css(["border:1px solid ", ";box-shadow:0px 0px 0px 3px ", ";@media (min-width:", "){outline:0;box-shadow:none;}"], function (props) {
  return props.theme.input.warningColor;
}, function (props) {
  return props.theme.input.warningShadow;
}, neutral.breakpoints.mobile);
var ErrorFocus = css(["border:1px solid ", ";box-shadow:0px 0px 0px 3px ", ";@media (min-width:", "){outline:0;box-shadow:none;}"], function (props) {
  return props.theme.input.errorColor;
}, function (props) {
  return props.theme.input.errorShadow;
}, neutral.breakpoints.mobile);
var InputStatus = css(["&.ant-form-item-has-error{.ant-input,.ant-input:not([disabled]):hover{border:1px solid ", ";&:focus{", "}}.ant-picker,.ant-picker:not(.ant-picker-disable):hover{border:1px solid ", ";&.ant-picker-focused{", "}}.ant-select.ant-select-single:not(.ant-select-customize-input),.ant-select.ant-select:not(.ant-select-disabled):hover{.ant-select-selector{border:1px solid ", ";}}.ant-select.ant-select-focused.ant-select-single:not(.ant-select-customize-input){.ant-select-selector{", "}}}&.ant-form-item-has-warning{.ant-input,.ant-input:not([disabled]):hover{border:1px solid ", ";&:focus{", "}}.ant-picker,.ant-picker:not(.ant-picker-disable):hover{border:1px solid ", ";&.ant-picker-focused{", "}}.ant-select.ant-select-single:not(.ant-select-customize-input),.ant-select.ant-select:not(.ant-select-disabled):hover{.ant-select-selector{border:1px solid ", ";}}.ant-select.ant-select-focused.ant-select-single:not(.ant-select-customize-input){.ant-select-selector{", "}}}"], function (props) {
  return props.theme.input.errorColor;
}, ErrorFocus, function (props) {
  return props.theme.input.errorColor;
}, ErrorFocus, function (props) {
  return props.theme.input.errorColor;
}, ErrorFocus, function (props) {
  return props.theme.input.warningColor;
}, WarningFocus, function (props) {
  return props.theme.input.warningColor;
}, WarningFocus, function (props) {
  return props.theme.input.warningColor;
}, WarningFocus);
var StyledFormControl = styled.label.withConfig({
  displayName: "Formstyles__StyledFormControl",
  componentId: "sc-haolkx-0"
})(["display:block;font-family:", ";font-size:", ";color:", ";", " .help-text{font-size:", ";color:", ";margin-top:", ";}.form-control-icon{position:absolute;top:50%;right:", ";z-index:1;width:32px;height:20px;margin-top:-8px;text-align:center;visibility:visible;-webkit-animation:zoomIn 0.3s cubic-bezier(0.12,0.4,0.29,1.46);animation:zoomIn 0.3s cubic-bezier(0.12,0.4,0.29,1.46);pointer-events:none;}&.status-hidden{.help-text{visibility:hidden;}}&.status-warning{.help-text{color:", ";}}&.status-error{.help-text{color:", ";}}"], function (props) {
  return props.theme.input.fontFamily;
}, function (props) {
  return props.theme.form.labelFontSize;
}, function (props) {
  return props.theme.form.labelColor;
}, InputStatus, function (props) {
  return props.theme.form.helpTextFontSize;
}, function (props) {
  return props.theme.form.helpInfoColor;
}, neutral.spacings.xxSmall, neutral.spacings.xxSmall, function (props) {
  return props.theme.form.helpWarningColor;
}, function (props) {
  return props.theme.form.helpErrorColor;
});

export { StyledFormControl };
//# sourceMappingURL=Form.styles.js.map
